import Raven from 'raven-js';
import { useEffect, useState } from 'react';
export const SOFTWARE_SELECTED_TAB_LOCAL_STORAGE_KEY = 'SOFTWARE_SELECTED_TAB';
export const usePreviouslySelectedTabStore = () => {
  const [previouslySelectedTab, setPreviouslySelectedTab] = useState(null);
  useEffect(() => {
    try {
      setPreviouslySelectedTab(localStorage.getItem(SOFTWARE_SELECTED_TAB_LOCAL_STORAGE_KEY));
    } catch (error) {
      Raven.captureMessage('Failed to get selected software tab', {
        extra: error
      });
    }
  }, []);

  const updatePreviouslySelectedTabStore = newSelectedTab => {
    try {
      localStorage.setItem(SOFTWARE_SELECTED_TAB_LOCAL_STORAGE_KEY, newSelectedTab);
    } catch (error) {
      Raven.captureMessage('Failed to set selected software tab', {
        extra: error
      });
    }
  };

  return {
    previouslySelectedTab,
    setPreviouslySelectedTab: updatePreviouslySelectedTabStore
  };
};